// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3YWYH","header":"ReportDetails_header__16FiP","title":"ReportDetails_title__2Fo9i","left":"ReportDetails_left__15qfb"};